// @flow
export const setTokens = ({ accessToken, refreshToken }) => {
	localStorage.setItem('accessToken', accessToken);
	localStorage.setItem('refreshToken', refreshToken);
};

export const getToken = (key: string = 'accessToken'): string => localStorage.getItem(key);

export const isLoggedIn = (): boolean => getToken() != null;

export const removeToken = () => {
	localStorage.removeItem('accessToken');
	localStorage.removeItem('refreshToken');
};



// WEBPACK FOOTER //
// src/lib/LoginUtils.js